"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SearchBar;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _icon = require("@site/pattern-library-utils/icon");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _search = _interopRequireDefault(require("@ux/search"));
var _siteSearchContext = require("../site-search-context");
var _motionFunctions = require("@site/pattern-library-core/motion-functions");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Wrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Wrapper",
  class: "pl-w1fj494p"
});
const SearchBarWrapper = /*#__PURE__*/(0, _react2.styled)("form")({
  name: "SearchBarWrapper",
  class: "pl-sqf6vjj"
});
const SearchInput = /*#__PURE__*/(0, _react2.styled)(_search.default)({
  name: "SearchInput",
  class: "pl-s1u6qm9m"
});
function SearchBar({
  _name,
  value,
  placeholder,
  clearAriaLabel,
  handleOnFocus,
  handleOnBlur,
  handleKeyDown,
  handleOnChange,
  ...rest
}) {
  const {
    handleOnConfirm,
    setIsActive
  } = (0, _react.useContext)(_siteSearchContext.SiteSearchContext);

  // Case : When the belowSearchBar is clicked, input loses focus, this will prevent to lose focus.
  (0, _react.useEffect)(() => {
    const flyout = document.querySelector('[data-cy="flyout"]');
    flyout.addEventListener('mousedown', e => {
      e.preventDefault();
    });
  }, []);
  const handleKeyDownIfEscape = e => {
    if (e.key === 'Escape') {
      setIsActive(false);
    }
    handleKeyDown(e);
  };
  return /*#__PURE__*/_react.default.createElement(Wrapper, {
    "data-cy": "bar-wrapper"
  }, /*#__PURE__*/_react.default.createElement(SearchBarWrapper, {
    role: "search",
    action: ""
  }, /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    name: "search",
    "data-cy": "icon",
    width: 24,
    height: 24
  }), /*#__PURE__*/_react.default.createElement(SearchInput, (0, _extends2.default)({}, rest, {
    "data-cy": "input",
    "data-searchterm": value,
    id: "site-search-input",
    placeholder: placeholder,
    "aria-label": placeholder,
    value: value,
    clearable: true,
    ariaLabels: {
      clear: clearAriaLabel
    },
    onChange: handleOnChange,
    onConfirm: handleOnConfirm,
    onFocus: handleOnFocus,
    onBlur: handleOnBlur,
    onKeyDown: handleKeyDownIfEscape,
    placement: "bottom"
  }, _patternLibraryUtils.tracking.create(`${_name}_input_bar`, false, false)))));
}
SearchBar.propTypes = {
  _name: _propTypes.default.string,
  id: _propTypes.default.string,
  placeholder: _propTypes.default.string,
  clearAriaLabel: _propTypes.default.string,
  value: _propTypes.default.string,
  handleOnFocus: _propTypes.default.func,
  handleOnBlur: _propTypes.default.func,
  handleKeyDown: _propTypes.default.func,
  handleOnChange: _propTypes.default.func,
  ..._search.default.propTypes
};